export enum EditableLabelsComponentTranslationKey {
    LABELS_TITLE = "editableLabelComponent.labelsTitle",
    LABELS_ASSIGNING = "editableLabelComponent.labelsAssigning",
    AVAILABLE_LABELS = "editableLabelComponent.availableLabels",
    ASSIGNED_LABELS = "editableLabelComponent.assignedLabels",
}
